// extracted by mini-css-extract-plugin
export default {"progressContainer":"styles__progressContainer__l_Np_","placeholderContainer":"styles__placeholderContainer__ofCYl"};